// extracted by mini-css-extract-plugin
export default {"browserFrame":"AH9EGikEi0sq8V4xlqjP","browserFrameBar":"ufOwn1XI4Ik3XXp16f8P"};